export const getNotificationSimpleText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const [ giftData ] = actions;
    const { title } = giftData;

    return title
}

export const getNotificationLikeText = (item: any, t: any) => {

    const {
        notificationText,
        initiator,
        actions,
    } = item;
    const firstLike = actions[0]?.likeInfo;
    const entity = firstLike?.entityInfo;
    const title = `${initiator?.displayedName} ${notificationText}`

    return `${title} ${entity?.entityTitle}`;
}

export const getNotificationLMSCommentText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkCommentInfo;
    if (!lmsInfo) return '';

    if (lmsInfo?.isTeacher) return `Преподаватель ${lmsInfo?.initiator?.name} ${lmsInfo?.initiator?.surName} оставил комментарий к вашему заданию на тему ${lmsInfo?.themeTitle}`
    return `${lmsInfo?.initiator?.name} ${lmsInfo?.initiator?.surName} ставил комментарий к теме ${lmsInfo?.themeTitle}`
}

export const getNotificationLMSApproveText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkApproveInfo;
    if (!lmsInfo) return '';

    if (lmsInfo?.isApprove) return `Ваша работа на тему "${lmsInfo?.themeTitle}" была проверена и одобрена преподавателем ${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName}`
    return `Ваша работа на тему "${lmsInfo?.themeTitle}" была проверена преподавателем ${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName} и требует доработки`
}

export const getNotificationLMSAddText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkAddInfo;
    if (!lmsInfo) return '';

    return `${lmsInfo?.student?.name} ${lmsInfo?.student?.surName} добавил домашнее задание на тему "${lmsInfo?.themeTitle}"`
}

export const getNotificationSendFileText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const [ fileData ] = actions;
    const { description, files, textParts, entityName } = fileData;

    const dividers: any = []
    textParts.forEach((divider: any) => {
        divider?.parts?.forEach((partObj: any) => {
            const part = Object.values(partObj).join("")
            dividers.push({
                part,
                link: divider?.link,
                entityId: divider?.entityId,
                entityType: divider?.entityType,
                type: divider?.linkType
            })
        })
    })

    let newDesc = description
    dividers.forEach((divider: any) => {
        const part = divider.part
        newDesc = newDesc.replace(part, `|${part}|`)
    })
    const dividedText = newDesc.split("|")

    return dividedText.map((textPart: any) => textPart).join(" ")
}

export const getNotificationCoauthorAddText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.projectCoAuthorInfo;

    if (!info) return '';

    return `${info?.account?.name} ${info?.account?.surName} ${t('notifications.coauthor_add')} ${info?.projectTitle}`
}

export const getNotificationCoauthorRemoveText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.projectCoAuthorInfo;

    if (!info) return '';

    return `${info?.account?.name} ${info?.account?.surName} ${t('notifications.coauthor_remove')} ${info?.projectTitle}`
}

export const getNotificationProjectBannedText = (item: any, t: any) => {
    const {
        actions,
    } = item;

    const info = actions?.[0]?.projectBannedInfo;

    if (!info) return '';

    const projectTitle = info?.projectTitle;
    const contexts = info?.contexts || [];
    const reasons = info?.reasons || [];

    const hasUnbanRequest = Array.isArray(contexts) && contexts.includes('unbanrequest');
    
    if (hasUnbanRequest) {
        return `${t('notifications.project_banned_1')}${projectTitle}${t('notifications.project_under_review')}`;
    }

    const BLOCKING_REASONS = [
        { value: 0, labelKey: 'project_edit.blocking_reason_adult_content' },
        { value: 1, labelKey: 'project_edit.blocking_reason_hatred_incitement' },
        { value: 2, labelKey: 'project_edit.blocking_reason_criticism_insults' },
        { value: 3, labelKey: 'project_edit.blocking_reason_disinformation' },
        { value: 4, labelKey: 'project_edit.blocking_reason_personal_information' },
        { value: 5, labelKey: 'project_edit.blocking_reason_suicide_drugs' },
        { value: 6, labelKey: 'project_edit.blocking_reason_violence_threats' },
        { value: 7, labelKey: 'project_edit.blocking_reason_extremism' },
        { value: 8, labelKey: 'project_edit.blocking_reason_prohibited_goods' },
        { value: 9, labelKey: 'project_edit.blocking_reason_impersonation' },
        { value: 10, labelKey: 'project_edit.blocking_reason_intellectual_property' },
        { value: 11, labelKey: 'project_edit.blocking_reason_spam' },
        { value: 12, labelKey: 'project_edit.blocking_reason_other' }
    ];

    const reasonsList = reasons
        .filter((reasonEnum: number) => reasonEnum !== 13)
        .map((reasonEnum: number) => {
            const reasonConfig = BLOCKING_REASONS.find(r => r.value === reasonEnum);
            return reasonConfig ? t(reasonConfig.labelKey) : null;
        })
        .filter(Boolean);
    const otherReasonText = info?.otherReason;
    if (reasons.includes(12) && otherReasonText) {
        const otherIndex = reasonsList.findIndex((text: string) => 
            text === t('project_edit.blocking_reason_other')
        );
        if (otherIndex !== -1) {
            reasonsList[otherIndex] = `${t('project_edit.blocking_reason_other')}: ${otherReasonText}`;
        }
    }

    if (reasonsList.length === 0) return '';

    const reasonsText = reasonsList.join(', ');

    return `${t('notifications.project_banned_1')}${projectTitle}${t('notifications.project_banned_2')}${reasonsText}.`;
}

export const getNotificationSimpleText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const [ giftData ] = actions;
    const { title } = giftData;

    return title
}

export const getNotificationLikeText = (item: any, t: any) => {

    const {
        notificationText,
        initiator,
        actions,
    } = item;
    const firstLike = actions[0]?.likeInfo;
    const entity = firstLike?.entityInfo;
    const title = `${initiator?.displayedName} ${notificationText}`

    return `${title} ${entity?.entityTitle}`;
}

export const getNotificationLMSCommentText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkCommentInfo;
    if (!lmsInfo) return '';

    if (lmsInfo?.isTeacher) return `Преподаватель ${lmsInfo?.initiator?.name} ${lmsInfo?.initiator?.surName} оставил комментарий к вашему заданию на тему ${lmsInfo?.themeTitle}`
    return `${lmsInfo?.initiator?.name} ${lmsInfo?.initiator?.surName} ставил комментарий к теме ${lmsInfo?.themeTitle}`
}

export const getNotificationLMSApproveText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkApproveInfo;
    if (!lmsInfo) return '';

    if (lmsInfo?.isApprove) return `Ваша работа на тему "${lmsInfo?.themeTitle}" была проверена и одобрена преподавателем ${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName}`
    return `Ваша работа на тему "${lmsInfo?.themeTitle}" была проверена преподавателем ${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName} и требует доработки`
}

export const getNotificationLMSAddText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkAddInfo;
    if (!lmsInfo) return '';

    return `${lmsInfo?.student?.name} ${lmsInfo?.student?.surName} добавил домашнее задание на тему "${lmsInfo?.themeTitle}"`
}

export const getNotificationSendFileText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const [ fileData ] = actions;
    const { description, files, textParts, entityName } = fileData;

    const dividers: any = []
    textParts.forEach((divider: any) => {
        divider?.parts?.forEach((partObj: any) => {
            const part = Object.values(partObj).join("")
            dividers.push({
                part,
                link: divider?.link,
                entityId: divider?.entityId,
                entityType: divider?.entityType,
                type: divider?.linkType
            })
        })
    })

    let newDesc = description
    dividers.forEach((divider: any) => {
        const part = divider.part
        newDesc = newDesc.replace(part, `|${part}|`)
    })
    const dividedText = newDesc.split("|")

    return dividedText.map((textPart: any) => textPart).join(" ")
}

export const getNotificationCoauthorAddText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.projectCoAuthorInfo;

    if (!info) return '';

    return `${info?.account?.name} ${info?.account?.surName} ${t('notifications.coauthor_add')} ${info?.projectTitle}`
}

export const getNotificationCoauthorRemoveText = (item: any, t: any) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.projectCoAuthorInfo;

    if (!info) return '';

    return `${info?.account?.name} ${info?.account?.surName} ${t('notifications.coauthor_remove')} ${info?.projectTitle}`
}

export const getNotificationProjectBannedText = (item: any, t: any) => {
    const {
        actions,
    } = item;

    const info = actions?.[0]?.projectBannedInfo;

    if (!info) return '';

    const projectTitle = info?.projectTitle;
    const contexts = info?.contexts || [];
    const reasons = info?.reasons || [];

    const hasUnbanRequest = Array.isArray(contexts) && contexts.includes('unbanrequest');
    
    if (hasUnbanRequest) {
        return `${t('notifications.project_banned_1')}${projectTitle}${t('notifications.project_under_review')}`;
    }

    const BLOCKING_REASONS = [
        { value: 0, labelKey: 'project_edit.blocking_reason_adult_content' },
        { value: 1, labelKey: 'project_edit.blocking_reason_hatred_incitement' },
        { value: 2, labelKey: 'project_edit.blocking_reason_criticism_insults' },
        { value: 3, labelKey: 'project_edit.blocking_reason_disinformation' },
        { value: 4, labelKey: 'project_edit.blocking_reason_personal_information' },
        { value: 5, labelKey: 'project_edit.blocking_reason_suicide_drugs' },
        { value: 6, labelKey: 'project_edit.blocking_reason_violence_threats' },
        { value: 7, labelKey: 'project_edit.blocking_reason_extremism' },
        { value: 8, labelKey: 'project_edit.blocking_reason_prohibited_goods' },
        { value: 9, labelKey: 'project_edit.blocking_reason_impersonation' },
        { value: 10, labelKey: 'project_edit.blocking_reason_intellectual_property' },
        { value: 11, labelKey: 'project_edit.blocking_reason_spam' },
        { value: 12, labelKey: 'project_edit.blocking_reason_other' }
    ];

    const reasonsList = reasons
        .filter((reasonEnum: number) => reasonEnum !== 13)
        .map((reasonEnum: number) => {
            const reasonConfig = BLOCKING_REASONS.find(r => r.value === reasonEnum);
            return reasonConfig ? t(reasonConfig.labelKey) : null;
        })
        .filter(Boolean);
    const otherReasonText = info?.otherReason;
    if (reasons.includes(12) && otherReasonText) {
        const otherIndex = reasonsList.findIndex((text: string) => 
            text === t('project_edit.blocking_reason_other')
        );
        if (otherIndex !== -1) {
            reasonsList[otherIndex] = `${t('project_edit.blocking_reason_other')}: ${otherReasonText}`;
        }
    }

    if (reasonsList.length === 0) return '';

    const reasonsText = reasonsList.join(', ');

    return `${t('notifications.project_banned_1')}${projectTitle}${t('notifications.project_banned_2')}${reasonsText}.`;
}

